/*
 * @Description: 路由信息
 * @Author: YH
 * @Date: 2023-03-02 15:04:13
 * @LastEditTime: 2023-03-03 17:09:45
 * @LastEditors: YH
 * @Reference:
 */

/**
 * 生成扁平化的路由列表
 * @param {array} router 树形结构的路由列表
 */
function generateFlatRouteList(router) {
  return router.reduce((obj, route) => {
    if (route.children?.length) {
      obj = { ...obj, ...generateFlatRouteList(route.children) };
    } else {
      obj[route.name] = route;
    }
    return obj;
  }, {});
}

/**
 * 处理设置菜单列表
 * @param {object} state 存储状态
 * @param {array} menuList 菜单列表
 */
function handleSetMenuList(state, menuList) {
  const menuNameList = Object.keys(generateFlatRouteList(menuList));

  menuNameList.forEach((name) => {
    if (state.flatRouteList[name]) {
      state.flatRouteList[name].meta = {
        ...(state.flatRouteList[name].meta || {}),
        auth: true,
      };
    }
  });
  state.menuList = menuList;
  state.menuNameList = menuNameList;
  localStorage.setItem("menuList", JSON.stringify(menuList));
}

export default {
  namespaced: true,
  state: {
    routeList: [], // 当前路由列表
    flatRouteList: [], // 扁平化处理的路由列表
    whiteRouteNameList: JSON.parse(localStorage.getItem("whiteRouteNameList") || "[]"), // 白名单路由名称列表
    menuList: JSON.parse(localStorage.getItem("menuList") || "[]"), // 当前用户权限内的菜单列表
    menuNameList: [], // 当前用户权限内的菜单名称列表
  },
  mutations: {
    /**
     * @name: 初始化路由信息
     * @param {object} state 存储状态
     * @param {array} value 路由列表
     */
    init(state, value) {
      const routeList = value || [];
      const flatRouteList = generateFlatRouteList(routeList);
      const whiteRouteNameList = Object.values(flatRouteList)
        .filter((route) => route.meta?.pass)
        .map((route) => route.name);

      state.routeList = routeList;
      state.flatRouteList = flatRouteList;
      state.whiteRouteNameList = whiteRouteNameList;
      localStorage.setItem("whiteRouteNameList", JSON.stringify(whiteRouteNameList));
      handleSetMenuList(state, state.menuList);
    },
    /**
     * 设置用户权限内的菜单列表
     * @param {object} state 存储状态
     * @param {list} value 菜单列表
     */
    setMenuList(state, value) {
      handleSetMenuList(state, value);
    },
  },
};
